export default () => ({
  alias                : process.env.APPLICATION_ALIAS,
  owner                : 'tenant',
  title                : process.env.APPLICATION_TITLE,
  description          : process.env.APPLICATION_DESCRIPTION,
  feature              : [],
  createAccountEnabled : false,
  logo                 : {
    light : require('@/assets/_core/img/logo-light.svg'),
    dark  : require('@/assets/_core/img/logo-dark.svg')
  },
  headerHeight         : 80,
  loginPageImage       : require('@/assets/_core/img/login_page_image.png'),
  isMobile             : false,
  captchaKey           : null,
  webThemeIsDark       : false,
  mobileThemeIsDark    : false,
  authenticationsModes : {},
  themes               : {
    favicon      : `${process.env.APPLICATION_ROUTE_BASE}/favicon.ico`,
    loadingColor : process.env.DEFAULT_PRIMARY_COLOR,
    light        : {
      primary   : process.env.DEFAULT_PRIMARY_COLOR,
      secondary : process.env.DEFAULT_SECONDARY_COLOR,
      accent    : process.env.DEFAULT_ACCENT_COLOR,
      grey      : process.env.DEFAULT_GREY_COLOR
    },
    isDark: false
  },
  snackbar: {
    showing : false,
    text    : '',
    type    : ''
  },
  dialog: {
    showing           : false,
    type              : 'info',
    message           : null,
    title             : null,
    confirmButtonText : null,
    checkboxOptions   : [],
    onConfirm         : null,
    onClose           : null
  },
  languages: [
    { id: 'pt-BR', img: require('@/assets/_core/img/languages/pt-BR.png') },
    { id: 'en', img: require('@/assets/_core/img/languages/en.png') },
    { id: 'es', img: require('@/assets/_core/img/languages/es.png') }
  ],
  independentTabsEnabled : process.env.INDEPENDENT_TABS_ENABLED === 'true',
  configShowFilter       : process.env.MENU_SEARCH_ENABLED === 'true',
  isOperation            : false,
  sidebarDrawer          : null,
  statusMini             : null,
  prepareLayoutv2        : false,
  layoutv2               : false
});
